module.exports = __webpack_public_path__ + "static/transition.cd53f1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/optimistic/transition.png
// module id = 2569
// module chunks = 42060573973176